const getPath = shape => (shape.get('path') ||
    `M0 0 L${shape.get('width')} 0 L${shape.get('width')} ${shape.get('height')} L0 ${shape.get('height')} Z`);

export default getPath;
